<footer class="footer-area text-center">
    <p>© Jove is Proudly Owned by <a href="https://hibootstrap.com/" target="_blank">HiBootstrap</a></p>
</footer>